"use strict";

exports.__esModule = true;
exports.HandsontableEditor = exports.EDITOR_TYPE = void 0;
var _handsontableEditor = require("./handsontableEditor");
exports.EDITOR_TYPE = _handsontableEditor.EDITOR_TYPE;
exports.HandsontableEditor = _handsontableEditor.HandsontableEditor;


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/editors/handsontableEditor/index.js
// module id = 313
// module chunks = 0